export class ProofreadNoteRequest {
    MemberID: number;
    NoteText: string;
}
